import { render, staticRenderFns } from "./MonitorInfo.vue?vue&type=template&id=70b4f0ec&scoped=true&"
import script from "./MonitorInfo.vue?vue&type=script&lang=js&"
export * from "./MonitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./MonitorInfo.vue?vue&type=style&index=0&id=70b4f0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4f0ec",
  null
  
)

export default component.exports